import MainContent from '@/components/layout/MainContent.vue'
import {
  _,
  allRoles,
  isAuthorized,
  lazyLoadView,
  piloteAndContributor,
  requiresInternal,
  setNavL2,
} from '@/router/routing'
import { incidentsContributionRoutes } from '@/contexts/incidents/Incidents.routes'
import { recurringTasksContributionRoutes } from '@/contexts/recurring-tasks/RecurringTasks.routes'
import { exemptionsContributionRoutes } from '@/contexts/exemptions/Exemptions.routes'
import { projectsSecurityContributionRoutes } from '@/contexts/projects-security/ProjectsSecurity.routes'
import { actionPlansContributionRoutes } from '@/contexts/action-plans/ActionPlans.routes'
import { risksContributionRoutes } from '@/contexts/risks/Risks.routes'
import { uiKitRoutes } from '@/ui-kit/routes/UiKit.routes'
import type { Route, RouteConfig } from 'vue-router'

export const myRoutes: RouteConfig = {
  path: '/my',
  name: 'myspace',
  component: MainContent,
  meta: {
    title: _('my space'),
    dummy: true,
    requires_auth: true,
    requires_tenant: true,
    requires_role: allRoles,
    is_authorized: (route: Route) => isAuthorized(route),
  },
  children: [
    uiKitRoutes,
    {
      path: '/home/:dashboardId?',
      name: 'home',
      component: () => lazyLoadView(import('@/views/HomeView.vue')),
      props: ({ params }: { params: { dashboardId: number | undefined } }) => ({
        routeDashboardId: params.dashboardId ? Number(params.dashboardId) : undefined,
      }),
      meta: {
        title: _('Cockpit'),
        icon: 'home',
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: allRoles,
        doc_id: 'home',
      },
    },
    {
      path: '/contributions',
      name: 'contributions',
      component: MainContent,
      meta: {
        title: _('Contributions'),
        icon: 'comment-alt-plus',
        dummy: true,
        multi: true,
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndContributor,
        is_authorized: (route: Route) => isAuthorized(route),
      },
      children: [
        {
          path: 'evaluations',
          name: 'evaluation',
          component: () => lazyLoadView(import('@/contexts/campaigns/CampaignsContributionView.vue')),
          beforeEnter: setNavL2,
          meta: {
            title: _('Evaluations'),
            icon: 'check-square',
            is_authorized: (route: Route) => isAuthorized(route),
            requires_auth: true,
            requires_tenant: true,
            requires_role: allRoles,
            doc_id: 'my_evaluations',
            nb_contribution: 'nb_evaluations',
          },
          children: [
            {
              path: 'eval/:campaign_id/:perimeter_id?/:control_id?/:questionnaire_id?',
              name: 'campaign_eval',
              component: () => lazyLoadView(import('@/contexts/campaigns/CampaignEvalView.vue')),
              meta: {
                title: null,
                is_authorized: (route: Route) => isAuthorized(route),
                requires_auth: true,
                requires_tenant: true,
                requires_role: allRoles,
                doc_id: 'campaign_eval',
              },
            },
            {
              path: 'results/:campaign_id/:perimeter_id?',
              name: 'campaign_details',
              component: () => lazyLoadView(import('@/contexts/campaigns/CampaignDetailsView.vue')),
              meta: {
                title: null,
                is_authorized: (route: Route) => isAuthorized(route),
                requires_auth: true,
                requires_tenant: true,
                requires_role: allRoles,
                doc_id: 'campaign_details',
              },
            },
          ],
        },
        actionPlansContributionRoutes,
        recurringTasksContributionRoutes,
        {
          path: 'metrics',
          name: 'gmetrics_entry',
          component: () => lazyLoadView(import('@/contexts/metrics/MetricsEntryView.vue')),
          beforeEnter: setNavL2,
          meta: {
            title: _('Metrics'),
            icon: 'chart-scatter',
            is_authorized: (route: Route) => isAuthorized(route),
            requires_auth: true,
            requires_tenant: true,
            requires_role: allRoles,
            requires_internal: () => requiresInternal(),
            doc_id: 'my_metrics',
            nb_contribution: 'nb_metrics',
          },
        },
        exemptionsContributionRoutes,
        risksContributionRoutes,
        incidentsContributionRoutes,
        projectsSecurityContributionRoutes,
      ],
    },
  ],
}
